import { Container, CustomImage } from '../shared';
import styles from './VioBanner.module.css';

export const VioBanner = () => {
  return (
    <section className={styles.vioBannerContainer}>
      <Container>
        <div className={styles.bannerContent}>
          <div className={styles.blurredGradient} />
          <div className={styles.logoWrapper}>
            <CustomImage
              className={styles.vioLogo}
              src="web_v2/womens-health/vio/ovusense-logo-1.png"
              alt="viO HealthTech Logo"
              width={100}
              height={60}
            />
          </div>
          <p className={styles.poweredByText}>
            powered by OvuSense™ technology
          </p>
          <p className={styles.descriptionText}>
            OvuSense™ is a clinically proven fertility tracking technology, CE
            and UKCA certified as a Class IIa medical device, and FDA registered
            in the US. Trusted by women in over 40 countries, it’s trained on
            more than 260,000 real-world cycles to deliver medical-grade
            accuracy in predicting and confirming ovulation, even for irregular
            cycles, PCOS/PMOS, or endometriosis.
          </p>
        </div>
      </Container>
    </section>
  );
};
